<ng-container [formGroup]="currentForm" *ngIf="!isMobileDeviceSize; else mobileForm">
  <div id="basic-info" class="grid-gap" [ngClass]="{ 'invisible' : !showBasicInfoPanel }">
    <app-instructions></app-instructions>

    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Basic Information
      </p>
    </div>
    <app-suggested-names [substanceType]="SubstanceType.SingleEntityAndSalt"></app-suggested-names>
    <app-designation-for-salt-form></app-designation-for-salt-form>
    <app-chemical-names [substanceType]="SubstanceType.SingleEntity" [shouldShowFullTitle]="true"></app-chemical-names>
    <app-chemical-names [substanceType]="SubstanceType.Salt" [shouldShowFullTitle]="true"></app-chemical-names>
    
    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showMolecularInfoPanel'" [displaySectionName]="'molecular information'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="molecular-info" class="grid-gap" [ngClass]="{ 'invisible' : !showMolecularInfoPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Molecular Information
      </p>
    </div>

    <app-molecular-info></app-molecular-info>
    <app-molecular-formula [substanceType]="SubstanceType.SingleEntity" [shouldShowFullTitle]="true"></app-molecular-formula>
    <app-molecular-formula [substanceType]="SubstanceType.Salt" [shouldShowFullTitle]="true"></app-molecular-formula>

    <app-molecular-weight [substanceType]="SubstanceType.SingleEntity" [shouldShowFullTitle]="true"></app-molecular-weight>
    <app-molecular-weight [substanceType]="SubstanceType.Salt" [shouldShowFullTitle]="true"></app-molecular-weight>

    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showSubstanceDetailsPanel'" [displaySectionName]="'substance details'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="substance-details" class="grid-gap" [ngClass]="{ 'invisible' : !showSubstanceDetailsPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Substance Details
      </p>
    </div>
    <app-pro-drug-precursor></app-pro-drug-precursor>
    <app-cas-registry [substanceType]="SubstanceType.SingleEntity" [shouldShowFullTitle]="true"></app-cas-registry>
    <app-cas-registry [substanceType]="SubstanceType.Salt" [shouldShowFullTitle]="true"></app-cas-registry>
    <app-unii-number></app-unii-number>
    <app-code-designations [substanceType]="SubstanceType.SingleEntity" [shouldShowFullTitle]="true"></app-code-designations>
    <app-code-designations [substanceType]="SubstanceType.Salt" [shouldShowFullTitle]="true"></app-code-designations>
    <app-trademarks></app-trademarks>
    <app-trivial-names></app-trivial-names>

    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showManufactureUsageInfoPanel'" [displaySectionName]="'manufacturer and usage info'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="manufacture-usage-info" class="grid-gap" [ngClass]="{ 'invisible' : !showManufactureUsageInfoPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Manufacturer and Usage Information
      </p>
    </div>
    <app-manufacturers></app-manufacturers>
    <app-principal-therapeutic-uses></app-principal-therapeutic-uses>
    <app-pharmacologic-action></app-pharmacologic-action>
    <app-substance-binds-to-target></app-substance-binds-to-target>
    <app-substance-binds-names></app-substance-binds-names>

    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showClinicalTrialInfoPanel'" [displaySectionName]="'clinical trial information'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="clinical-trial-info" class="grid-gap" [ngClass]="{ 'invisible' : !showClinicalTrialInfoPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Clinical Trial Information
      </p>
    </div>
    <app-phase-one-trial-date></app-phase-one-trial-date>
    <app-ind-app-numbers></app-ind-app-numbers>
    <app-existing-inn-name></app-existing-inn-name>
    <app-inn-explanation></app-inn-explanation>

    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showUploadDocumentsPanel'" [displaySectionName]="'upload documents'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="upload-documents" class="grid-gap" [ngClass]="{ 'invisible' : !showUploadDocumentsPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Upload Documents
      </p>
    </div>
    <upload-documents-instructions></upload-documents-instructions>
    <app-absence-of-conflict></app-absence-of-conflict>
    <!-- <app-trademark-search-results></app-trademark-search-results> -->
    <app-structural-formula [substanceType]="SubstanceType.SingleEntity" [shouldShowFullTitle]="true"></app-structural-formula>
    <app-structural-formula [substanceType]="SubstanceType.Salt" [shouldShowFullTitle]="true"></app-structural-formula>
    <app-cas-registry-info></app-cas-registry-info>
    <app-sequence></app-sequence>
    <app-nucleic-acid-salts></app-nucleic-acid-salts>
    <app-cover-letter></app-cover-letter>
    <app-additional-documentation></app-additional-documentation>
       
    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showApplicantInfoPanel'" [displaySectionName]="'applicant information'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="applicant-info" class="grid-gap" [ngClass]="{ 'invisible' : !showApplicantInfoPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Applicant Information
      </p>
    </div>
    <app-applicant-info></app-applicant-info>

    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showPaymentInfoPanel'" [displaySectionName]="'payment information'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="payment-info" class="grid-gap" [ngClass]="{ 'invisible' : !showPaymentInfoPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Payment Information
      </p>
    </div>
    <app-payment-info></app-payment-info>
    
    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showTermsAndConditionsPanel'" [displaySectionName]="'terms and conditions'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="terms-conditions" class="grid-gap" [ngClass]="{ 'invisible' : !showTermsAndConditionsPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Terms and Conditions
      </p>
    </div>
    <app-terms-conditions></app-terms-conditions>
    
    <div class="no-gap">
      <app-agree-submit-button></app-agree-submit-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
</ng-container>
<ng-template #mobileForm>
  <div class="usan-form-item">
    <app-instructions></app-instructions>

    <mat-accordion class="stretch panel-gap">
      <mat-expansion-panel (opened)="basicInfoPanel = true; scrollToSection('basic-info')" (closed)="basicInfoPanel = false" id="basic-info">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            Basic Information
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Basic Information')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <app-suggested-names [substanceType]="SubstanceType.SingleEntityAndSalt"></app-suggested-names>
        <app-designation-for-salt-form></app-designation-for-salt-form>
        <app-chemical-names [substanceType]="SubstanceType.SingleEntity" [shouldShowFullTitle]="true"></app-chemical-names>
        <app-chemical-names [substanceType]="SubstanceType.Salt" [shouldShowFullTitle]="true"></app-chemical-names>
     
        <app-form-nav-button [sectionName]="'showMolecularInfoPanel'" [displaySectionName]="'molecular information'"></app-form-nav-button>
        <app-save-draft-button></app-save-draft-button>

      </mat-expansion-panel>


      <mat-expansion-panel (opened)="showMolecularInfoPanel = true; scrollToSection('molecular-info')" (closed)="showMolecularInfoPanel = false" id="molecular-info">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            <span>Molecular Information</span>
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Molecular Information')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-molecular-info></app-molecular-info>
        <app-molecular-formula [substanceType]="SubstanceType.SingleEntity" [shouldShowFullTitle]="true"></app-molecular-formula>
        <app-molecular-formula [substanceType]="SubstanceType.Salt" [shouldShowFullTitle]="true"></app-molecular-formula>
        <app-molecular-weight [substanceType]="SubstanceType.SingleEntity" [shouldShowFullTitle]="true"></app-molecular-weight>
        <app-molecular-weight [substanceType]="SubstanceType.Salt" [shouldShowFullTitle]="true"></app-molecular-weight>
        <app-save-draft-button></app-save-draft-button>

      </mat-expansion-panel>


      <mat-expansion-panel (opened)="showSubstanceDetailsPanel = true; scrollToSection('substance-details')" (closed)="showSubstanceDetailsPanel = false" id="substance-details">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            <span>Substance Details</span>
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Substance Details')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-cas-registry [substanceType]="SubstanceType.SingleEntity" [shouldShowFullTitle]="true"></app-cas-registry>
        <app-cas-registry [substanceType]="SubstanceType.Salt" [shouldShowFullTitle]="true"></app-cas-registry>
        <app-unii-number></app-unii-number>
        <app-code-designations [substanceType]="SubstanceType.SingleEntity" [shouldShowFullTitle]="true"></app-code-designations>
        <app-code-designations [substanceType]="SubstanceType.Salt" [shouldShowFullTitle]="true"></app-code-designations>
        <app-trademarks></app-trademarks>
        <app-trivial-names></app-trivial-names>
        <app-save-draft-button></app-save-draft-button>
        
      </mat-expansion-panel>


      <mat-expansion-panel (opened)="showManufactureUsageInfoPanel = true; scrollToSection('manufacture-usage-info')" (closed)="showManufactureUsageInfoPanel = false" id="manufacture-usage-info">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            Manufacturer and Usage Information
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Manufacturer and Usage Information')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-manufacturers></app-manufacturers>
        <app-principal-therapeutic-uses></app-principal-therapeutic-uses>
        <app-pharmacologic-action></app-pharmacologic-action>
        <app-substance-binds-to-target></app-substance-binds-to-target>
        <app-substance-binds-names></app-substance-binds-names>
        <app-save-draft-button></app-save-draft-button>

      </mat-expansion-panel>


      <mat-expansion-panel (opened)="showClinicalTrialInfoPanel = true; scrollToSection('clinical-trial-info')" (closed)="showClinicalTrialInfoPanel = false" id="clinical-trial-info">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            Clinical Trial Information
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Clinical Trial Information')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-phase-one-trial-date></app-phase-one-trial-date>
        <app-ind-app-numbers></app-ind-app-numbers>
        <app-existing-inn-name></app-existing-inn-name>
        <app-inn-explanation></app-inn-explanation>
        <app-save-draft-button></app-save-draft-button>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="showUploadDocumentsPanel = true; scrollToSection('upload-documents')" (closed)="showUploadDocumentsPanel = false" id="upload-documents">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            Upload Documents
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Upload Documents')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <upload-documents-instructions></upload-documents-instructions>
        <app-absence-of-conflict></app-absence-of-conflict>
       <!-- <app-trademark-search-results></app-trademark-search-results> -->
        <app-structural-formula [substanceType]="SubstanceType.SingleEntity" [shouldShowFullTitle]="true"></app-structural-formula>
        <app-structural-formula [substanceType]="SubstanceType.Salt" [shouldShowFullTitle]="true"></app-structural-formula>
        <app-cas-registry-info></app-cas-registry-info>
        <app-sequence></app-sequence>
        <app-nucleic-acid-salts></app-nucleic-acid-salts>
        <app-cover-letter></app-cover-letter>
        <app-additional-documentation></app-additional-documentation>
        <app-save-draft-button></app-save-draft-button>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="showApplicantInfoPanel = true; scrollToSection('applicant-info')" (closed)="showApplicantInfoPanel = false" id="applicant-info">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            Applicant Information
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Applicant Information')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-applicant-info></app-applicant-info>
        <app-save-draft-button></app-save-draft-button>
      </mat-expansion-panel>


      <mat-expansion-panel (opened)="showPaymentInfoPanel = true; scrollToSection('payment-info')" (closed)="showPaymentInfoPanel = false" id="payment-info">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            Payment Information
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Payment Information')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-payment-info></app-payment-info>
        <app-save-draft-button></app-save-draft-button>
      </mat-expansion-panel>



      <mat-expansion-panel (opened)="showTermsAndConditionsPanel = true; scrollToSection('terms-conditions')" (closed)="showTermsAndConditionsPanel = false" id="terms-conditions">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">Terms and Conditions</mat-panel-title>
        </mat-expansion-panel-header>
        <app-terms-conditions></app-terms-conditions>
        <app-agree-submit-button></app-agree-submit-button>
        <app-save-draft-button></app-save-draft-button>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</ng-template>